import { dispatchPromise } from './action-helpers';

export const removeBackgroundTask = taskId => {
    return dispatchPromise({
        type: 'BACKGROUND_TASK_REMOVE',
        payload: { taskId }
    });   
}
